export default __webpack_public_path__ + "text-similar920f31.png";